(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManageUsersController', ManageUsersController);

    ManageUsersController.$inject = ['authentication','$modal','$state','$q','config','$window'];

    function ManageUsersController(authentication,$modal,$state,$q,config,$window) {
        var vm = this;

        vm.isLoading = true;
        vm.isWaiting = false; // Used for disabling all buttons when one is pressed
        vm.formSuccess = "";
        vm.formError = "";
        vm.displayInfoWhenErrored = false;

        vm.onClickDashboard = onClickDashboard;
        vm.onSearchAllUsers = onSearchAllUsers;
        vm.onSearchUser = onSearchUser;
        vm.onSearchUserCAS = onSearchUserCAS;
        vm.onSearchUserAFWP = onSearchUserAFWP;
        vm.onEnable = onEnable;
        vm.setAccountDisabled = setAccountDisabled;
        vm.onPasswordReset = onPasswordReset;
        vm.onManageUserEmail = onManageUserEmail;
        vm.onAdminEditing = onAdminEditing;
        vm.onClickRemoveCAC = onClickRemoveCAC;
        vm.onAFWPAdminEditing = onAFWPAdminEditing;
        vm.onCheckActivity = onCheckActivity;
        vm.currentEmail = "";
        vm.isEmpty = true;
        vm.isAccountEnableable = false;
        vm.isAccountDisabled = false;
        vm.isDisabledDueToPw = false;
        vm.isDisabledDueToInactivity = false;
        vm.isAccountAdmin = false;
        vm.isAccountAFWPAdmin = null;
        vm.manageUserEmailText = "Edit User Email";
        vm.adminButtonText = "Make CAS Admin";
        vm.afwpAdminButtonText = "Make AFWP Admin";
        vm.isAdmin = false;
        vm.isAfwpAdmin = false;
        vm.doesUserExistInAFWP = false;
        vm.searchResult =
            {
                casId: null,
                lastActive: null,
                admin: null,
                verified: null,
                disableDate: null,
                isCacRegistered: null
            };
        vm.searchResults = [];
        vm.searchString = "";
        vm.searchEmail = "";
        vm.currentStatus = "";
        vm.passwordAttemptsThreshold = null;
        vm.numberOfDaysUntilInactive = null;
        vm.tempPassword = "";
        vm.resetPassword = false;

        activate();

        function activate() {
            authentication.getCasInfoForUser(authentication.getEmail())
                .then(function (casInfo) {
                    vm.isAdmin = casInfo.user.admin;
                    vm.currentEmail = casInfo.user.email;

                    config.get().then(function(configData){
                        vm.passwordAttemptsThreshold = configData.cas.failedPasswordCount;
                        vm.numberOfDaysUntilInactive = configData.cas.numberOfDaysUntilInactive;
                        authentication.getUserProfile().then(function(userInfo){
                            for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                                if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                                    vm.isAfwpAdmin = true;
                                }
                            }
                            vm.isLoading = false;
                        });
                    });
                })
                .catch(function (error) {
                    // Fixes endless loading by catching the error for logged out users and setting appropriate flags to false.
                    vm.isAfwpAdmin = false;
                    vm.isAdmin = false;
                    vm.isLoading = false;
                });
        }

        function onClickDashboard() {
            return $state.go('accountManagement.dashboard', null, { reload: true });
        }

        function onSearchAllUsers() {
            if(!vm.searchString){
                vm.searchEmail = "";
                vm.searchResults=[];
            }

            if(vm.isAdmin){
                return getAllCasUsers()
                    .then(function(){
                        onSearchUser();
                    });
            }
            else {
                onSearchUser();
            }
        }

        function onSearchUser() {

            vm.formError = "";
            vm.displayInfoWhenErrored = false;

            if(vm.isAdmin && vm.isAfwpAdmin){

                return onSearchUserCAS()
                    .then(function(){
                        vm.displayInfoWhenErrored = true;
                    })
                    .catch(function(err){
                        vm.formError = err;
                    })
                    .finally(function(){
                        return onSearchUserAFWP()
                            .then(function(){
                                vm.displayInfoWhenErrored = true;
                            })
                            .catch(function(err){
                                if (vm.formError.length > 0) {
                                    vm.formError += ". ";
                                }
                                vm.formError += err;
                            });
                    });
            }

            else if(vm.isAdmin){
                return getAllCasUsers()
                    .then(function(){
                        return onSearchUserCAS()
                            .then(function () {
                                vm.displayInfoWhenErrored = true;
                            })
                            .catch(function (err) {
                                vm.formError = err;
                            });
                });
            }

            else if(vm.isAfwpAdmin){
                vm.searchEmail = vm.searchString;
                return onSearchUserAFWP()
                    .then(function(){
                        vm.displayInfoWhenErrored = true;
                    })
                    .catch(function(err){
                    vm.formError = err;
                });
            }

        }

        function getAllCasUsers() {

            return authentication.getCasInfoForUsers(vm.searchString)
                .then(function (casInfo) {
                    vm.searchResults = casInfo.users;
                    if(casInfo.users.length > 0) {
                        casInfo.users[0].isChecked = true;
                        vm.searchEmail = casInfo.users[0].email;
                    }
                    else {
                        vm.searchEmail = "";
                    }
                })
                .catch(function (error) {
                    vm.searchResult.casId = null;
                    vm.searchResult.lastActive = null;
                    vm.searchResult.admin = null;
                    vm.searchResult.email = null;
                    vm.searchResult.verified = null;
                    vm.searchResult.disableDate = null;
                    vm.searchResult.lastFailedLoginDate = null;
                    vm.searchResult.deleted = null;
                    vm.searchResult.failedPasswordCount = null;
                    vm.searchResult.isCacRegistered = null;
                    vm.searchResult.lastLoginTime = null;
                    vm.searchResult.lastLoginMethod = null;
                    vm.searchResult.createdDate = null;
                    vm.isEmpty = true;
                    vm.isAccountDisabled = false;
                    vm.isAccountEnableable = false;
                    vm.disabledDueToPw = false;
                    vm.disabledDueToInactivity = false;
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address or partial email does not exist in CAS";
                    });

        }

        function onSearchUserCAS() {
            vm.currentStatus = "";
            return authentication.getCasInfoForUser(vm.searchEmail)
                .then(function (casInfo) {
                    vm.searchResult.casId = casInfo.user.id ? casInfo.user.id : "none";
                    vm.searchResult.lastActive = casInfo.user.lastSuccessfulLogin ? moment(casInfo.user.lastSuccessfulLogin).format('lll') : "none";
                    vm.searchResult.admin = casInfo.user.admin ? casInfo.user.admin : false;
                    vm.searchResult.deleted = casInfo.user.deleted ? casInfo.user.deleted : false;
                    vm.searchResult.email = casInfo.user.email ? casInfo.user.email : "none";
                    vm.searchResult.verified = casInfo.user.emailVerified ? casInfo.user.emailVerified : false;
                    vm.searchResult.disableDate = casInfo.user.disableDate ? moment(casInfo.user.disableDate).format('lll') : "none";
                    vm.searchResult.lastFailedLoginDate = casInfo.user.lastFailedLoginDate ? moment(casInfo.user.lastFailedLoginDate).format('lll') : "none";
                    vm.searchResult.lastLoginTime = casInfo.user.lastLoginTime ? moment(casInfo.user.lastLoginTime).format('lll') : "none";
                    vm.searchResult.createdDate = casInfo.user.createdDate ? moment(casInfo.user.createdDate).format('lll') : "none";
                    vm.searchResult.lastLoginMethod = casInfo.user.lastLoginMethod ? casInfo.user.lastLoginMethod : "none";
                    vm.searchResult.failedPasswordCount = isNaN(casInfo.user.failedPasswordCount) ? "none": casInfo.user.failedPasswordCount;
                    vm.searchResult.isCacRegistered = casInfo.user.cacid === "yes";
                    vm.isEmpty = isEmpty();
                    vm.isAccountDisabled = isAccountDisabled();
                    vm.isDisabledDueToPw = isDisabledDueToPW();
                    vm.isDisabledDueToInactivity = isDisabledDueToInactivity();
                    vm.isAccountAdmin = isAccountAdmin();
                    vm.adminButtonText = vm.isAccountAdmin?"Remove CAS Admin":"Make CAS Admin";
                    vm.isWaiting = false;


                    if(vm.searchResult.deleted){
                        vm.currentStatus = "Deleted";
                        vm.isAccountEnableable = true;
                    }

                    else {
                        if (!vm.isAccountDisabled && !vm.isDisabledDueToPw && !vm.isDisabledDueToInactivity) {
                            vm.currentStatus = "Enabled";
                            vm.isAccountEnableable = false;
                        }

                        else {
                            vm.isAccountEnableable = true;

                            vm.currentStatus = "Disabled due to: " + (vm.isAccountDisabled ? 'admin ' : "") + (vm.isDisabledDueToPw ? 'password attempts ' : "") +
                                (vm.isDisabledDueToInactivity ? ' inactivity' : "");

                        }
                    }

                })
                .catch(function (error) {
                    vm.searchResult.casId = null;
                    vm.searchResult.lastActive = null;
                    vm.searchResult.admin = null;
                    vm.searchResult.email = null;
                    vm.searchResult.verified = null;
                    vm.searchResult.disableDate = null;
                    vm.searchResult.lastFailedLoginDate = null;
                    vm.searchResult.deleted = null;
                    vm.searchResult.failedPasswordCount = null;
                    vm.searchResult.isCacRegistered = null;
                    vm.searchResult.lastLoginTime = null;
                    vm.searchResult.lastLoginMethod = null;
                    vm.searchResult.createdDate = null;
                    vm.isEmpty = true;
                    vm.isAccountDisabled = false;
                    vm.isAccountEnableable = false;
                    vm.disabledDueToPw = false;
                    vm.disabledDueToInactivity = false;
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address or partial email does not exist in CAS";
                });
        }

        function onSearchUserAFWP() {
            return authentication.getUserProfile(vm.searchEmail)
                .then(function(resultUser){
                    vm.isAccountAFWPAdmin = false;
                    for (var i = 0; i < resultUser.aosUser.aosRoles.length; i++) {
                        if (resultUser.aosUser.aosRoles[i] === "AFWP Administrator") {
                            vm.isAccountAFWPAdmin = true;
                        }
                    }
                    vm.isEmpty = isEmpty();
                    vm.doesUserExistInAFWP = true;
                    vm.afwpAdminButtonText = vm.isAccountAFWPAdmin?"Remove AFWP Admin":"Make AFWP Admin";
                    vm.isWaiting = false;
                })
                .catch(function(error){
                    vm.doesUserExistInAFWP = false;
                    vm.isAccountAFWPAdmin = null;
                    vm.afwpAdminButtonText = "Make AFWP Admin";
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address does not exist in AFWP";
                });
        }

        function setAccountDisabled() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    if(!vm.isAccountDisabled){
                        return authentication.disableUser(vm.searchResult.email, proxyTicket.proxyTicket)
                            .then(function (result) {
                                return onSearchUser();
                            });
                    }
                })
                .catch(function (err) {
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onEnable() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    return authentication.resetUser(vm.searchResult.email, proxyTicket.proxyTicket)
                        .then(function (result) {
                            return onSearchUser();
                        });
                })
                .catch(function (err) {
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onPasswordReset() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {

                    $modal.open({
                        templateUrl: 'app/components/manageUsers/confirmPasswordReset.view.html',
                        controller: 'ConfirmPasswordResetController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        keyboard: 'false',
                        resolve: {
                            email: function () {
                                return vm.searchResult.email;
                            }
                        }
                    }).result.then(function () {
                        return authentication.resetPassword(vm.searchResult.email, proxyTicket.proxyTicket)
                                .then(function (result) {
                                    $modal.open({
                                        templateUrl: 'app/components/manageUsers/showTempPassword.view.html',
                                        controller: 'ShowTempPasswordController',
                                        controllerAs: 'vm',
                                        backdrop: 'static',
                                        keyboard: 'false',
                                        resolve: {
                                            email: function () {
                                                return vm.searchResult.email;
                                            },
                                            tempPassword: function () {
                                                return result.id;
                                            }
                                        }
                                    }).result.then(function () {});
                                    return onSearchUser();
                                });
                        })
                        .catch(function (err) {
                            vm.isWaiting = false;
                            vm.formError = err;
                            vm.displayInfoWhenErrored = true;
                            return onSearchUser();
                        });
                    });
                    return onSearchUser();
        }

        function onManageUserEmail() {
            $modal.open({
                templateUrl: 'app/components/manageUsers/manageUsersEmail.view.html',
                controller: 'ManageUsersEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    email: function () {
                        return vm.searchResult.email;
                    }
                }
            }).result.then(function () {
                // vm.formError = '';
                // vm.formSuccess = '';
            });
        }

        function onAdminEditing() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    return authentication.setAdminStatus(vm.searchResult.email,vm.isAccountAdmin,proxyTicket.proxyTicket)
                        .then(function (result) {
                            return onSearchUser();
                        })
                        .catch(function(err){
                            vm.isWaiting = false;
                            vm.formError = err;
                            vm.displayInfoWhenErrored = true;
                            return onSearchUser();
                        });
                })
                .catch(function(err){
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onClickRemoveCAC() {
            vm.isWaiting = true;
            authentication.getProxyTicket().then(function (response) {
                return config.get().then(function (configData) {
                    $window.location.href = configData.casUserAdmin + 'rest/removeCac?service=' + $window.location.href + '&pt=' + response.proxyTicket +'&userEmail='+ vm.searchResult.email;
                    vm.isWaiting = false;
                });
            }).catch(function (error) {
                vm.isWaiting = false;
                vm.formError = error;
                vm.displayInfoWhenErrored = true;
            });
        }

        function onCheckActivity(position,results) {
            angular.forEach(results,function(resultSet,index){
                if(position != index){
                    resultSet.isChecked = false;
                }
            });
            vm.searchEmail = results[position].email;
            onSearchUser();

        }

        function onAFWPAdminEditing() {
            vm.isWaiting = true;
            return authentication.setAdminStatusAFWP(vm.searchEmail,vm.isAccountAFWPAdmin)
                .then(function(result){
                    return onSearchUser();
                })
                .catch(function(err){
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return;
                });
        }

        function isEmpty() {
            if(vm.isAfwpAdmin && vm.isAdmin) {
                return (vm.isAccountAFWPAdmin === null && vm.searchResult.casId === null && vm.searchResult.lastActive === null && vm.searchResult.email === null && vm.searchResult.admin === null && vm.searchResult.verified === null &&
                     vm.searchResult.disableDate === null && vm.searchResult.lastFailedLoginDate === null && vm.searchResult.deleted === null && vm.searchResult.failedPasswordCount === null && vm.searchResult.isCacRegistered == null &&
                     vm.searchResult.lastLoginTime == null && vm.searchResult.lastLoginMethod == null && vm.searchResult.createdDate == null);
            }

            else if(vm.isAfwpAdmin){
                return (vm.isAccountAFWPAdmin === null);
            }

            else if(vm.isAdmin){
                return (vm.searchResult.casId === null && vm.searchResult.lastActive === null && vm.searchResult.email === null && vm.searchResult.admin === null && vm.searchResult.verified === null && vm.searchResult.disableDate === null &&
                    vm.searchResult.lastFailedLoginDate === null && vm.searchResult.deleted === null && vm.searchResult.failedPasswordCount === null && vm.searchResult.isCacRegistered == null && vm.searchResult.lastLoginTime == null &&
                    vm.searchResult.lastLoginMethod == null && vm.searchResult.createdDate == null);
            }
        }

        function isAccountDisabled() {
            return (vm.searchResult.disableDate !== "none");
        }

        function isDisabledDueToPW() {
            return (vm.searchResult.failedPasswordCount > vm.passwordAttemptsThreshold);
        }

        function isDisabledDueToInactivity() {
            return ((moment(vm.searchResult.lastActive).add(vm.numberOfDaysUntilInactive,'days')) < moment());
        }

        function isAccountAdmin () {
            return (vm.searchResult.admin);
        }
    }
})();